export default __webpack_public_path__ + "static/media/close.ada63a51.svg";